import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.jsx";
import { recordUserAction } from "./tracking.js";

function screenFromPath(pathname) {
  if (pathname === "/" || pathname === "/onboarding") return "today";
  if (pathname === "/leads") return "leads";
  if (pathname === "/leads/settings") return "lead_settings";
  if (pathname === "/crm") return "crm";
  if (pathname === "/projects") return "projects";
  if (pathname === "/money") return "money";
  if (pathname === "/profile") return "profile";
  if (pathname === "/analytics") return "analytics";
  if (pathname === "/settings/plan") return "plan";
  if (pathname === "/settings") return "settings";
  return null;
}

export function ProductAnalytics() {
  const auth = useAuth();
  const location = useLocation();
  const lastScreenRef = useRef(null);
  const screen = screenFromPath(location.pathname);

  useEffect(() => {
    if (auth.status !== "authenticated" || !screen || lastScreenRef.current === screen) return;
    lastScreenRef.current = screen;
    void recordUserAction(auth, {
      name: "app.screen_viewed",
      entityType: "app_screen",
      entityId: screen,
    });
  }, [auth, screen]);

  return null;
}
